<div *ngIf="isLoading | async" class="spinner-container d-flex m-3 justify-content-center">
    <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>